var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComplete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1688 27.0303H10.2972V10.2972L19.3073 1.28711L20.9163 2.89606C21.0664 3.04623 21.19 3.25003 21.287 3.50746C21.3839 3.7649 21.432 4.0116 21.4311 4.24758V4.69809L20.0153 10.2972H27.0303C27.7168 10.2972 28.3175 10.5547 28.8323 11.0695C29.3472 11.5844 29.6046 12.1851 29.6046 12.8716V15.4459C29.6046 15.5961 29.5887 15.757 29.557 15.9286C29.5252 16.1002 29.4768 16.2611 29.4116 16.4113L25.5501 25.4858C25.357 25.9148 25.0352 26.2795 24.5847 26.5798C24.1342 26.8802 23.6622 27.0304 23.1688 27.0303ZM7.72287 10.2972V27.0303H2.57422V10.2972H7.72287Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.da569f0e585d05060dd910f597e4e1b8.svg";
export { ForwardRef as ReactComponent };